import { useMemo } from 'react';
import { DateRangeBoundary } from './constants.js';

var useDateRangeOffset = function useDateRangeOffset(offsets, rangeBoundary, inclusiveStart, inclusiveEnd) {
  return useMemo(function () {
    switch (rangeBoundary) {
      case DateRangeBoundary.Start:
        return inclusiveStart ? offsets.InclusiveStart : offsets.ExclusiveStart;

      case DateRangeBoundary.End:
        return inclusiveEnd ? offsets.InclusiveEnd : offsets.ExclusiveEnd;

      default:
        return 0;
    }
  }, [offsets, rangeBoundary, inclusiveStart, inclusiveEnd]);
};

var useDateRangeOffset$1 = useDateRangeOffset;

export { useDateRangeOffset$1 as default };
